import { useGenericDialogContext } from '../Context';

export type DialogMode = 'Confirm';
export const useDialogContext = useGenericDialogContext<DialogMode>;
